import _axios from "../../..";
import { Company, RevenueModel } from "../../../../types";
import { RemoveCompanyProfileProps } from "../tyoes";

const RevenueModelService = {
  getAll: async (): Promise<RevenueModel[]> =>
    (await _axios.get("revenue-model")).data,

  create: async (body: string[], company_id: Company["id"]): Promise<void> =>
    (await _axios.post(`revenue-model/${company_id}`, { revenue_ids: body }))
      .data,

  remove: async ({
    id,
    company_id,
    company_profile_id,
  }: RemoveCompanyProfileProps): Promise<void> =>
    await _axios.delete(`revenue-model/relation${id ? `/${id}` : ""}`, {
      data: { company_id, company_profile_id },
    }),
};

export default RevenueModelService;
